import { Component } from 'react';
import { getDisplayName } from '../../../common/utils/getDisplayName';

interface IDisplayFullNameProps {
    id?: string | null;
    nameFamily?: string | null;
    nameFamily2?: string | null;
    nameGiven?: string | null;
    nameInfix?: string | null;
    nameInfix2?: string | null;
    nameInitials?: string | null;
    nameUsual?: string | null;
}

export class DisplayFullName extends Component<IDisplayFullNameProps, {}> {
    public render() {
        return <>{getDisplayName(this.props)}</>;
    }
}
